var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    { attrs: { appBarTitle: _vm.$tr("appBarTitle"), route: _vm.backRoute } },
    [
      _c(
        "KPageContainer",
        { staticClass: "device-container" },
        [
          _c(
            "KGrid",
            [
              _c(
                "KGridItem",
                { attrs: { layout8: { span: 5 }, layout12: { span: 8 } } },
                [
                  _c("h1", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$tr("tasksHeader")) +
                        "\n        "
                    ),
                  ]),
                ]
              ),
              _c(
                "KGridItem",
                {
                  attrs: {
                    layout8: { span: 3, alignment: "right" },
                    layout12: { span: 4, alignment: "right" },
                  },
                },
                [
                  _vm.showClearCompletedButton
                    ? _c("KButton", {
                        class: { "button-offset": _vm.windowIsLarge },
                        attrs: { text: _vm.$tr("clearCompletedAction") },
                        on: { click: _vm.handleClickClearAll },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.loading
            ? _c("KLinearLoader", {
                attrs: { delay: false, type: "indeterminate" },
              })
            : _vm._e(),
          !_vm.loading && _vm.managedTasks.length === 0
            ? _c("p", { staticClass: "empty-tasks-message" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.deviceString("emptyTasksMessage")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _c(
            "transition-group",
            { staticClass: "task-panels", attrs: { name: "fade" } },
            _vm._l(_vm.sortedTaskList, function (task) {
              return _c("TaskPanel", {
                key: task.id,
                staticClass: "task-panel",
                style: { borderBottomColor: _vm.$themePalette.grey.v_200 },
                attrs: { task: task },
                on: {
                  clickclear: function ($event) {
                    return _vm.handleClickClear(task)
                  },
                  clickcancel: function ($event) {
                    return _vm.handleClickCancel(task)
                  },
                },
              })
            }),
            1
          ),
          _vm.immersivePage
            ? _c(
                "BottomAppBar",
                [
                  _c("KButton", {
                    attrs: {
                      text: _vm.coreString("continueAction"),
                      appearance: "raised-button",
                      primary: true,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleRedirectToImportPage()
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }